import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';

import Footer from './shared/Footer';
import { withTranslation } from "react-i18next";
import axios from 'axios';
import Users from '../model/Users'
import ModalLoading from './shared/ModalCostum/ModalLoading'
import ModalErrorDisconnect from './shared/ModalCostum/ModalErrorDisconnect'
import SwallCostum from './shared/Swall/SwallCostum'
class App extends Component {
  state = {}
  componentDidMount() {
    this.onRouteChanged();
    
    const self = this

    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Authorization, X-Requested-With';
    axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, OPTIONS, PUT, DELETE';
    axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
    axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
    axios.interceptors.request.use(function (config) {
      // spinning start to show
      self.setState({ShowModalLoading:true})
      return config
    }, function (error) {
      self.setState({ShowModalLoading:false})
      return Promise.reject(error);
    });
    
    axios.interceptors.response.use(function (response) {
      self.setState({ShowModalLoading:false})

      if(typeof response.data.info !== "undefined" ){
        console.log(response.data.info);
        if(response.data.info.add ===true){
          return SwallCostum.ConfrimAddSucess(()=> response)
        }if(response.data.info.update ===true){
          return SwallCostum.ConfrimUpdateSucess(()=> response)
        }if(response.data.info.delete ===true){
          return SwallCostum.ConfrimDeleteSucess(()=> response)
        }if(response.data.info.delete ===false){
          return SwallCostum.ConfrimFailedDelete(()=> response)
        }if(response.data.info.add ===false){
          return SwallCostum.ConfrimFailedAdd(()=> response)
        }if(response.data.info.add ===false){
          return SwallCostum.ConfrimFailedUpdate(()=> response)
        }if(response.data.info.set_status ===true){
          return SwallCostum.ConfrimSwitchCustom(response.data.info.message, ()=> response)
        }if(response.data.info.update_password === false){
          return SwallCostum.ConfrimResetPasswordCustomError(response.data.info.message, ()=> response)
        }else{
          return response;
        }
      }else{
        return response;
      }
    }, function (error) {

      self.setState({ShowModalLoading:false})

      if (!error.response) {

        self.setState({ShowModalErroDc:true})
        Promise.reject(error)
       
      } else {
        // return error;
        // http status code
        const code = error.response.status
        console.log(code)
        if(code==404 && error.response.data.meta.status ===false){
          SwallCostum.ConfrimFailedCostum("Oopss..",error.response.data.meta.message,()=>null )
        } else if(  code==404 ){
          SwallCostum.ConfrimFailedCostum("Oopss..","Maaf, Terjadi Kesalahaan Saat Memuat, Klik Oke untuk memuat ulang",()=>window.location.reload(true) )
        } else  if(  code==500 ){
          SwallCostum.ConfrimFailedCostum("Oopss..","Maaf, Terjadi Kesalahaan Saat Memuat, Klik Oke untuk memuat ulang",()=>window.location.reload(true) )

        }
        
        // response data
        // const response = error.response.data
        
      }
      return error;
      //  return Promise.reject(error);
    });
  }
  render () {
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar/> : '';
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar/> : '';
   
    let footerComponent = !this.state.isFullPageLayout ? <Footer/> : '';
    return (
      <div className="container-scroller">
        { navbarComponent }
        <div className="container-fluid page-body-wrapper">
          { sidebarComponent }
          <div className="main-panel">
            <div className="content-wrapper">
              <AppRoutes/>
           
            </div>
            { footerComponent }
          </div>
        </div>
        <ModalLoading ShowModal={this.state.ShowModalLoading}  SetShowModalHide={()=>this.setState({ShowModalLoading:false})}  />
        <ModalErrorDisconnect ShowModalErroDc={this.state.ShowModalErroDc} setShowModalErroDc={()=>this.setState({ShowModalErroDc:false})} />
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if(typeof Users.get() !== "undefined" &&  Users.get() !== null && Object.keys(Users.get()).length !==0){
      axios.defaults.headers.common['Authorization'] = typeof Users.get() !== "undefined" &&  Users.get() !== null && Object.keys(Users.get()).length !==0  ? "Bearer "+Users.get().token:'';
    }
    
  
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();

    
    }
  }

  onRouteChanged() {

    const { i18n } = this.props;
    const body = document.querySelector('body');
    if(this.props.location.pathname === '/layout/RtlLayout') {
      body.classList.add('rtl');
      i18n.changeLanguage('ar');
    }
    else {
      body.classList.remove('rtl')
      i18n.changeLanguage('en');
    }
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      '/login', 
      '/general-pages/landing-page',
      '/self-register',
      '/create-password',
      '/forgot-password'
    ];
    for ( let i = 0; i < fullPageLayoutRoutes.length; i++ ) {
      if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
        this.setState({
          isFullPageLayout: true
        })
        document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
        break;
      } else {
        this.setState({
          isFullPageLayout: false
        })
        document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
      }
    }
  }

}

export default withTranslation()(withRouter(App));
